import { render, staticRenderFns } from "./batchModifyFreezeOrder.vue?vue&type=template&id=24df5aa5&scoped=true"
import script from "./batchModifyFreezeOrder.vue?vue&type=script&lang=ts"
export * from "./batchModifyFreezeOrder.vue?vue&type=script&lang=ts"
import style0 from "./batchModifyFreezeOrder.vue?vue&type=style&index=0&id=24df5aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df5aa5",
  null
  
)

export default component.exports